import * as Dialog from "radix-ui/dialog";
import { X } from "lucide-react";
import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router";

import { useAuth } from "../../lib/auth";
import { titleForPath } from "../../route-meta";
import { IconButton } from "../ui/Controls";
import { Navigation } from "./Navigation";
import { TopBar } from "./TopBar";

export function AppShell() {
  const auth = useAuth();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const title = titleForPath(location.pathname);

  useEffect(() => {
    document.title = `${title} · WebYönetim`;
    setDrawerOpen(false);
    const frame = window.requestAnimationFrame(() => {
      const heading = document.querySelector<HTMLElement>("main h1");
      heading?.setAttribute("tabindex", "-1");
      heading?.focus();
    });
    return () => {
      window.cancelAnimationFrame(frame);
    };
  }, [location.pathname, title]);

  const logout = () => {
    void auth.logout();
  };
  const navigation = (
    <Navigation
      displayName={auth.identity?.user.displayName ?? "Hesap"}
      installationLabel="Yerel kurulum"
      onLogout={logout}
      onNavigate={() => {
        setDrawerOpen(false);
      }}
      isOwner={auth.identity?.membership.role === "owner"}
      permissions={auth.identity?.permissions ?? []}
    />
  );

  return (
    <div className="shell">
      <a className="skip-link" href="#main-content">
        Ana içeriğe geç
      </a>
      <aside aria-label="Uygulama gezinmesi" className="rail">
        {navigation}
      </aside>
      <div className="shell__body">
        <TopBar
          onLogout={logout}
          onMenu={() => {
            setDrawerOpen(true);
          }}
          title={title}
        />
        <main id="main-content" tabIndex={-1}>
          <Outlet />
        </main>
      </div>
      <Dialog.Root onOpenChange={setDrawerOpen} open={drawerOpen}>
        <Dialog.Portal>
          <Dialog.Overlay className="dialog-overlay" />
          <Dialog.Content
            aria-describedby={undefined}
            aria-label="Gezinme menüsü"
            className="mobile-drawer"
            onCloseAutoFocus={(event) => {
              event.preventDefault();
              document
                .querySelector<HTMLButtonElement>('[aria-label="Gezinme menüsünü aç"]')
                ?.focus();
            }}
          >
            <div className="cluster" style={{ justifyContent: "space-between" }}>
              <Dialog.Title>Gezinme menüsü</Dialog.Title>
              <Dialog.Close asChild>
                <IconButton
                  icon={<X aria-hidden="true" size={24} strokeWidth={1.75} />}
                  label="Gezinme menüsünü kapat"
                />
              </Dialog.Close>
            </div>
            {navigation}
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </div>
  );
}

export function PageHeader({
  action,
  description,
  title,
}: {
  readonly action?: React.ReactNode;
  readonly description?: string | undefined;
  readonly title: string;
}) {
  return (
    <header className="page-header">
      <div>
        <h1>{title}</h1>
        {description === undefined ? null : <p>{description}</p>}
      </div>
      {action}
    </header>
  );
}
